import TTBold from "@tiptap/extension-bold"
import type { Mark as ProsemirrorMark, Schema } from "@tiptap/pm/model"

import { BoldExtension } from "./BoldModel"

const componentName = "bold"

const component = TTBold.extend({
  name: componentName,
})

const converter = {
  fromPrismic(schema: Schema) {
    return function (): ProsemirrorMark | undefined {
      return schema.marks[component.name]?.create()
    }
  },

  toPrismic() {
    return undefined
  },
}

const EditorBold = new BoldExtension(componentName, component, converter)

// eslint-disable-next-line import/no-default-export
export default EditorBold
